/**
 * 平台自助广告主核心配置文件，修改务必考虑清楚对业务的影响
 */
import { getAthenaLink } from '@byted/tt_ads_public_config';

/**
 * 有通用规则的欧洲国家
 * 已全量: 波兰【PL】； 捷克【CZ】；爱尔兰【IE】；奥地利【AT】；瑞典【SE】
 */
const commonEuCountryInfo = [
  {
    country: 'PL', // 波兰
    hide: false, // 是否需要隐藏，邮件邀请时为true，全量开放时设为false
  },
  {
    country: 'CZ', // 捷克
    hide: false,
  },
  {
    country: 'IE', // 爱尔兰
    hide: false,
  },
  {
    country: 'AT', // 奥地利
    hide: false,
  },
  {
    country: 'SE', // 瑞典
    hide: false,
  },
  {
    country: 'BE', // 比利时
    hide: false,
  },
  {
    country: 'NL', // 荷兰
    hide: false,
  },
  {
    country: 'FI', // 芬兰
    hide: false,
  },
  {
    country: 'PT', // 葡萄牙
    hide: false,
  },
  {
    country: 'GR', // 希腊
    hide: false,
  },
  {
    country: 'DK', // 丹麦
    hide: false,
  },
  {
    country: 'RO', // 罗马尼亚 | Romania
    hide: false,
  },
  {
    country: 'HU', // 匈牙利 | Hungary
    hide: false,
  },
  {
    country: 'UA', // 乌克兰 | Ukraine
    hide: false,
  },
  {
    country: 'NO', // 挪威 ｜  Norway
    hide: false,
  },
  {
    country: 'CH', // 瑞士 ｜ Switzerland
    hide: false,
  },
];
const commonEUCountryListAccount = commonEuCountryInfo.map((item) => {
  const { country, hide } = item;
  return {
    country,
    hide,
  };
});

export const whiteAccountCountry = [
  {
    country: 'IN', // 印度
    hide: true,
  },
  {
    country: 'VN', // 越南
    hide: false,
  },
  {
    country: 'KR', // 韩国
    hide: false,
  },
  {
    country: 'AE', // 阿联酋
    hide: false,
  },
  {
    country: 'EG', // 埃及
    hide: false,
  },
  {
    country: 'SA', // 沙特阿拉伯
    hide: false,
  },
  {
    country: 'TW', // 中国台湾
    hide: true,
  },
  {
    country: 'RU', // 俄罗斯
    hide: false,
  },
  {
    country: 'ID', // 印度尼西亚
    hide: false,
  },
  {
    country: 'TH', // 泰国
    hide: false,
  },
  {
    country: 'MY', // 马来西亚
    hide: false,
  },
  {
    country: 'JP', // 日本
    hide: false,
  },
  {
    country: 'TR', // 土耳其
    hide: false,
  },
  {
    country: 'IL', // 以色列
    hide: false,
  },
  {
    country: 'AU', // 澳大利亚
    hide: false,
  },
  {
    country: 'US', // 美国
    hide: false,
  },
  {
    country: 'GB', // 英国
    hide: false,
  },
  {
    country: 'FR', // 法国
    hide: false,
  },
  {
    country: 'IT', // 意大利
    hide: false,
  },
  {
    country: 'ES', // 西班牙
    hide: false,
  },
  {
    country: 'SG', // 新加坡
    hide: false,
  },
  {
    country: 'DE', // 德国
    hide: false,
  },
  {
    country: 'CA', // 加拿大
    hide: false,
  },
  {
    country: 'PH', // 菲律宾
    hide: false,
  },
  ...commonEUCountryListAccount,
  {
    country: 'NZ', // 新西兰
    hide: false,
  },
  {
    country: 'KW', // 科威特
    hide: false,
  },
  {
    country: 'QA', // 卡塔尔
    hide: false,
  },
  {
    country: 'BR', // 巴西 | Brazil
    hide: false,
  },
  {
    country: 'KH', // 柬埔寨 | Cambodia
    hide: false,
  },
  {
    country: 'ZA', // 南非 | South Africa
    hide: false,
  },
  {
    country: 'MA', // 摩洛哥 | Morocco
    hide: false,
  },
  {
    country: 'MX', // 墨西哥 | Mexico
    hide: false,
  },
  {
    country: 'CL', // 智利 | Chile
    hide: false,
  },
  {
    country: 'PE', // 秘鲁 | Peru
    hide: true,
  },
  {
    country: 'EC', // 厄瓜多尔 | Ecuador
    hide: true,
  },
];

/**
 * 自助支付方式
 * hide:是否开放
 * value: 与ocrm沟通定义的值，manual = 1， automatic = 2
 */
export const accountPaymentOptions = {
  automatic: {
    value: '2',
    title: 'self_ac_payment_automatic',
    icon: require('src/assets/images/payment/auto-pay.png'),
    info: 'module_paymethod_postpay_tips',
    infoV2: 'module_auto_payment_method_tips_v2',
    tagKey: 'module_auto_payment_method_tag',
    oldInfo: 'module_payment_type_automatic_info',
  },
  manual: {
    value: '1',
    title: 'self_ac_payment_manual',
    icon: require('src/assets/images/payment/manual-pay.png'),
    info: 'module_paymethod_prepay_tips',
    tagKey: 'module_manual_payment_method_tag',
    oldInfo: 'module_payment_type_manual_info',
  },
};
/**
 * 信用卡卡组类型
 * name: 卡组名称
 * imgSrc: 卡组示例图片
 * imgIcon: 卡组icon
 */
export const cardsMap = [
  {
    name: 'VISA',
    imgSrc: require('src/assets/images/credit-visa.png'),
    imgIcon: require('src/assets/images/credit-visa-icon.png'),
    newImg: require('src/assets/images/credit-visa-new.png'),
  },
  {
    name: 'MASTER',
    imgSrc: require('src/assets/images/credit-mc.png'),
    imgIcon: require('src/assets/images/credit-mc-icon.png'),
    newImg: require('src/assets/images/credit-mc-new.png'),
  },
  {
    name: 'AMEX',
    imgSrc: require('src/assets/images/credit-ae.png'),
    imgIcon: require('src/assets/images/credit-ae-icon.png'),
    newImg: require('src/assets/images/credit-ae-new.png'),
  },
  {
    name: 'JCB',
    imgSrc: require('src/assets/images/credit-jcb.png'),
    imgIcon: require('src/assets/images/credit-jcb-icon.png'),
    newImg: require('src/assets/images/credit-jcb-new.png'),
  },
  {
    name: 'CB',
    imgSrc: require('src/assets/images/credit-ce.png'),
    imgIcon: require('src/assets/images/credit-ce-icon.png'),
    newImg: require('src/assets/images/credit-ce-new.png'),
  },
  {
    name: 'PAYPAL',
    imgSrc: require('src/assets/images/credit-pp-new.png'),
    imgIcon: require('src/assets/images/credit-pp-new.png'),
    newImg: require('src/assets/images/credit-pp-new.png'),
  },
];

export const athenaLink = () => {
  const id = window.PERMISSION_DATA?.account?.id || '';
  return getAthenaLink(id);
};

// 只显示省不显示city的国家
export const disableCityCountry = [
  'US',
  'FR',
  'IT',
  'ES',
  'RU',
  'GB',
  'IL',
  'SA',
  'SG',
  'DE',
  'CA',
  'PH',
  'NZ',
  'KW',
  'QA',
  'KH',
  ...commonEuCountryInfo.map(item => item.country),
];
